import React from 'react';
import ReactTooltip from 'react-tooltip';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import styles from './PrivateImages.module.scss';

const MAX_IMAGE_COUNT = 11;

const DeleteButton = ({ onClick }) => (
  <button
    type="button"
    className={classNames(styles.deleteButton, 'naked-button')}
    onClick={onClick}
  >
    <i className="fal fa-times" />
  </button>
);

const PrivateImages = ({ images, handleRemove }) => {
  const isDropDisabled = images?.length >= MAX_IMAGE_COUNT;
  return (
    <div>
      <div className={styles.titleContainer}>
        <p>Private Images</p>
        <span
          data-tip="These images will be hidden from the product gallery. Any JPGs converted to PNGs will also be moved to this group."
          data-for="privateImages"
        >
          <i className="fas fa-info-circle" />
        </span>
      </div>
      <Droppable
        droppableId="privateImageUrls"
        isDropDisabled={isDropDisabled}
        direction="horizontal"
      >
        {(provided) => (
          <div
            {...provided.droppableProps}
            ref={provided.innerRef}
            className={styles.container}
          >
            {images.map((item, index) => {
              return (
                <Draggable key={item} draggableId={item} index={index}>
                  {(draggableProvided) => (
                    <div
                      ref={draggableProvided.innerRef}
                      {...draggableProvided.draggableProps}
                      {...draggableProvided.dragHandleProps}
                      className={styles.imageContainer}
                      style={draggableProvided.draggableProps.style}
                    >
                      <img
                        src={item}
                        alt="private-png"
                        className={styles.image}
                      />
                      <DeleteButton
                        onClick={() => handleRemove(index, 'privateImageUrls')}
                      />
                    </div>
                  )}
                </Draggable>
              );
            })}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
      <ReactTooltip
        id="privateImages"
        place="top"
        type="dark"
        effect="solid"
        //eslint-disable-next-line
        html={true}
        className={styles.tooltip}
      />
    </div>
  );
};

PrivateImages.propTypes = {
  images: PropTypes.arrayOf(PropTypes.string).isRequired,
  handleRemove: PropTypes.func.isRequired,
};

export default PrivateImages;
